import { PropsWithChildren } from 'react'

import { classNames } from '@/utils/helpers'

interface FormSectionProps {
  className?: string
  isLast?: boolean
}

export const FormSection = ({
  children,
  className,
  isLast,
}: PropsWithChildren<FormSectionProps>) => {
  return (
    <div
      className={classNames(
        'flex justify-between py-6',
        'max-md:flex-col max-md:gap-4',
        !isLast && 'border-b',
        className,
      )}
    >
      {children}
    </div>
  )
}
